import { render } from "./CoursesArea.vue?vue&type=template&id=cee8acfa"
import script from "./CoursesArea.vue?vue&type=script&lang=js"
export * from "./CoursesArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__